/**
 * LTI Enroll Exam
 * LTI Enroll Exam for Students
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The InlineObject1 model module.
 * @module model/InlineObject1
 * @version 2.0.0
 */
class InlineObject1 {
    /**
     * Constructs a new <code>InlineObject1</code>.
     * @alias module:model/InlineObject1
     */
    constructor() { 
        
        InlineObject1.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>InlineObject1</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/InlineObject1} obj Optional instance to populate.
     * @return {module:model/InlineObject1} The populated <code>InlineObject1</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new InlineObject1();

            if (data.hasOwnProperty('files')) {
                obj['files'] = ApiClient.convertToType(data['files'], [File]);
            }
            if (data.hasOwnProperty('document_type_id')) {
                obj['document_type_id'] = ApiClient.convertToType(data['document_type_id'], 'String');
            }
            if (data.hasOwnProperty('formative_action_ids')) {
                obj['formative_action_ids'] = ApiClient.convertToType(data['formative_action_ids'], 'String');
            }
        }
        return obj;
    }


}

/**
 * Archivo a subir
 * @member {Array.<File>} files
 */
InlineObject1.prototype['files'] = undefined;

/**
 * ID del tipo de documento
 * @member {String} document_type_id
 */
InlineObject1.prototype['document_type_id'] = undefined;

/**
 * ID de asignaturas separadas por coma
 * @member {String} formative_action_ids
 */
InlineObject1.prototype['formative_action_ids'] = undefined;






export default InlineObject1;

